//收款定义
import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 状态
 */
class receiveState extends UltMeta {
    /**
     * 待支付
     */
    PENDING_PAYMENT = new Meta(1, "待支付");
    /**
     * 待确认支付
     */
    PENDING_CONFIRM = new Meta(4, "待确认支付");
    /**
     * 已支付 (线上)
     */
    PAID = new Meta(2, "已支付 (线上)");
    /**
     * 已支付 (线下)
     */
    OFFLINE_PAID = new Meta(5, "已支付 (线下)");
    /**
     * 未支付
     */
    UNPAID = new Meta(3, "未支付");
}
export const RECEIVE_STATE = new receiveState();

/**
 * 状态
 */
class pcReceiveState extends UltMeta {
    /**
     * 待支付
     */
    PENDING_PAYMENT = new Meta(1, "待支付");
    /**
     * 待确认支付
     */
    PENDING_CONFIRM = new Meta(4, "待确认支付");
    /**
     * 已支付 (线上)
     */
    PAID = new Meta(2, "已支付");
    /**
     * 已支付 (线下)
     */
    OFFLINE_PAID = new Meta(5, "已支付");
    /**
     * 未支付
     */
    UNPAID = new Meta(3, "未支付");
}
export const PC_RECEIVE_STATE = new pcReceiveState();

/**
 * 支付类型
 */
class PaymentType extends UltMeta {
    /**
     * 订单货款
     */
    ORDER_PAYMENT = new Meta(5, "订单货款");
    /**
     * 订单定金
     */
    ORDER_DEPOSIT = new Meta(1, "订单定金");
    /**
     * 排期货款
     */
    ADVANCE_PAYMENT = new Meta(2, "排期货款");
    /**
     * 发航货款
     */
    SHIPPING_PAYMENT = new Meta(3, "发航货款");
    /**
     * 开仓货款
     */
    WAREHOUSE_OPENING_PAYMENT = new Meta(4, "开仓货款");
}
export const PAYMENT_TYPE = new PaymentType();

/**
 * 费用类型 （不包括排期货款）
 */
class PaymentTypeExcludeSchedule extends UltMeta {
    /**
     * 订单货款
     */
    ORDER_PAYMENT = new Meta(5, "订单货款");
    /**
     * 订单定金
     */
    ORDER_DEPOSIT = new Meta(1, "订单定金");
    /**
     * 发航货款
     */
    SHIPPING_PAYMENT = new Meta(3, "发航货款");
    /**
     * 开仓货款
     */
    WAREHOUSE_OPENING_PAYMENT = new Meta(4, "开仓货款");
}
export const PAYMENT_TYPE_EXCLUDE_SCHEDULE = new PaymentTypeExcludeSchedule();

/**
 * 凭证提交类型
 */
class PaymentSubmitType extends UltMeta {
    /**
     * 用户提交
     */
    CUSTOMER = new Meta(1, "用户提交");
    /**
     * 平台提交
     */
    PLATFORM = new Meta(2, "平台提交");
    /**
     * 用户提交后平台修改
     */
    UPDATE_PLATFORM = new Meta(3, "用户提交后平台修改");
}
export const PAYMENT_SUBMIT_TYPE = new PaymentSubmitType();
